import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * Clase para metodos que evaluan el contenido de algun formulario
 */
export class FormChecks {
    static checkMayus(control: AbstractControl): { [key: string]: any } | null {
        const inputValue: string = control.value;
        return /.*[A-Z].*/.test(inputValue) ? null : { notMayus: true };
    }

    static checkMinus(control: AbstractControl): { [key: string]: any } | null {
        const inputValue: string = control.value;
        return /.*[a-z].*/.test(inputValue) ? null : { notMinus: true };
    }

    static checkNumber(control: AbstractControl): { [key: string]: any } | null {
        const inputValue: string = control.value;
        return /\d/.test(inputValue) ? null : { notNumber: true };
    }

    static checkSpecialCharacter(control: AbstractControl): { [key: string]: any } | null {
        const inputValue: string = control.value;
        return /.*[\W_].*/.test(inputValue) ? null : { notSpecialCharacter: true };
    }

    static checkIfEqual(group: AbstractControl): ValidationErrors | null {
        const pass = group.get('newPassword');
        const confirm = group.get('confirmPassword');

        if (!pass || !confirm) return null;

        const password = pass.value;
        const confirmPassword = confirm.value;

        if (password !== confirmPassword) {
            confirm.setErrors({ notEqual: true });
            return { notEqual: true };
        } else {
            // Limpia solo si no hay otros errores
            if (confirm.hasError('notEqual')) {
                confirm.setErrors(null);
            }
            return null;
        }
    }
}
